import React from 'react'

const BookCallIcon = () => (
  <svg
    width="180"
    height="164"
    viewBox="0 0 180 164"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.5 113.435C-22.9999 80.5 40.9251 54.9901 56.9964 53.4977C92.7185 50.1835 73.4081 40.185 85.0394 29.243C96.6707 18.3009 140.649 36.3033 129.145 64.4188C117.64 92.5342 155.619 61.3288 171.704 96.9413C174.034 102.109 175.156 107.754 174.982 113.435C174.779 119.437 173.256 125.318 170.526 130.646C165.389 140.833 160.276 144.209 155.215 147.738M155.215 147.738C153.178 148.58 157.442 147.065 155.215 147.738Z"
      stroke="#E2E2FC"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeDasharray="2.8 2.8"
    />
    <path
      d="M176.561 27C176.561 22.5817 172.979 19 168.561 19H88C83.5817 19 80 22.5817 80 27V47.1531C80 51.5713 83.5817 55.1531 88 55.1531H159.571L157.734 62.5L167.377 55.1531H168.561C172.979 55.1531 176.561 51.5713 176.561 47.1531V27Z"
      fill="#E2E2FC"
    />
    <path
      d="M93.9216 93.9514C92.4718 95.2129 89.4636 98.4925 89.0288 101.52C88.6253 104.329 92.5576 107.355 95.0087 108.784C115.482 110.508 157.081 112.873 159.69 108.548C162.951 103.142 162.408 99.3575 160.233 93.9514C158.059 88.5454 148.276 86.9236 143.384 76.6521C145.377 73.048 148.928 64.6506 147.189 59.8933C145.014 53.9467 137.948 48 124.36 48C110.771 48 103.9 56 101 63.5C98.8731 69 105.239 74.198 108.5 76C105.903 80.8885 94.7167 82.297 92 85C89.8266 87.1624 92.6536 92.1494 93.9216 93.9514Z"
      fill="white"
    />
    <path
      d="M95.5513 109.088C95.3812 108.997 95.1994 108.896 95.0087 108.784M95.0087 108.784C92.5576 107.355 88.6253 104.329 89.0288 101.52C89.4636 98.4925 92.4718 95.2129 93.9216 93.9514C92.6536 92.1494 89.8266 87.1624 92 85C94.7167 82.297 105.903 80.8885 108.5 76C105.239 74.198 98.8731 69 101 63.5C103.9 56 110.771 48 124.36 48C137.948 48 145.014 53.9467 147.189 59.8933C148.928 64.6506 145.377 73.048 143.384 76.6521C148.276 86.9236 158.059 88.5454 160.233 93.9514C162.408 99.3575 162.951 103.142 159.69 108.548C157.081 112.873 115.482 110.508 95.0087 108.784Z"
      stroke="#011533"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M95.7867 93.2221C94.3767 94.4634 91.4509 97.6911 91.028 100.67C90.6356 103.435 94.4601 106.413 96.844 107.82C116.756 109.515 156.462 112.375 159 108.119C162.172 102.798 161.836 98.2418 159.5 94C156.747 89 147.258 87.1085 142.5 77C144.438 73.4532 148.192 64.6818 146.5 60C144.385 54.1477 138.216 48.5 125 48.5C111.784 48.5 105.831 56.5124 103.188 63.4287C101.073 68.9618 106.888 73.8918 110.06 75.6653C109.003 80.9855 97.3718 82.5816 94.7295 85.2417C92.6156 87.3698 94.5535 91.4486 95.7867 93.2221Z"
      fill="#004360"
    />
    <path
      d="M107.096 90.5528C110.287 90.9074 115.927 91.7169 117.203 90.4403C118.79 88.8538 120.902 84.6386 119.881 80.9309C117.852 81.1983 115.52 80.7784 113.48 78.7381C108.693 73.9509 109.757 64.3764 116.139 56.9296C117.203 55.6885 118.908 53.8792 120.927 53.2065C124.118 52.1427 128.374 51.0786 131.565 55.3339C134.757 59.5892 128.374 76.0786 127.842 79.802C127.31 83.5254 126.246 88.8445 128.905 90.4403C131.565 92.036 144.861 92.1485 146.457 93.2123C143.443 96.9357 133.267 104.914 120.927 104.914C105.501 104.914 103.372 97.4676 107.096 90.5528Z"
      fill="white"
      stroke="#011533"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M114.543 58.6382C115.784 58.8155 118.373 59.8084 118.798 62.3616C119.224 64.9148 116.848 66.9715 115.607 67.6807"
      stroke="#011533"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M116.67 71.9357C117.734 72.113 120.287 72.2549 121.989 71.4038C122.166 72.4676 120.819 74.1698 118.266 74.5953"
      stroke="#011533"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="114.845"
      cy="63.6086"
      rx="1.06383"
      ry="1.59574"
      transform="rotate(26 114.845 63.6086)"
      fill="#011533"
    />
    <ellipse
      cx="122.893"
      cy="64.6726"
      rx="1.06383"
      ry="1.59574"
      transform="rotate(26 122.893 64.6726)"
      fill="#011533"
    />
    <path
      d="M122.516 62.0292C119.386 59.6357 118.024 54.7159 117.734 52.5552V52.0566C125.559 46.5717 135.123 49.5635 137.732 53.5525C139.818 56.7437 138.891 62.5278 138.166 65.0209C134.254 65.0209 125.646 64.4226 122.516 62.0292Z"
      fill="#004360"
    />
    <path
      d="M117.734 53.3188C118.266 55.9784 119.33 59.7018 123.585 62.3614C126.813 64.3786 135.11 64.8437 139.011 65.021"
      stroke="#011533"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M86.8818 121.404L75.1797 143.213H94.8605L107.095 121.404H99.1159H86.8818Z"
      stroke="#1D2943"
      strokeWidth="1.4"
    />
    <path
      d="M82.0938 121.936H86.3491H97.3841C97.7147 122.926 98.1372 123.816 98.5831 124.596C100.285 127.574 100.356 140.553 100.179 148H148.583C146.633 141.44 142.413 130.447 141.136 128.319C139.86 126.192 142.732 123.887 144.328 123L141.136 119.277C148.229 119.809 162.626 119.809 163.477 115.553C161.775 107.894 151.42 97.4681 146.455 93.2128C143.264 96.7589 133.264 103.745 118.796 103.319C104.328 102.894 105.321 94.6312 107.626 90.5532C105.498 90.5532 103.548 91.2624 102.838 91.6171C98.1576 93.3192 87.0583 112.539 82.0938 121.936Z"
      fill="#E2E2FC"
    />
    <path
      d="M101.243 107.043C96.1973 113.057 96.137 118.204 97.3841 121.936M97.3841 121.936C97.7147 122.926 98.1372 123.816 98.5831 124.596C100.285 127.574 100.356 140.553 100.179 148H148.583C146.633 141.44 142.413 130.447 141.136 128.319C139.86 126.192 142.732 123.887 144.328 123L141.136 119.277C148.229 119.809 162.626 119.809 163.477 115.553C161.775 107.894 151.42 97.4681 146.455 93.2128C143.264 96.7589 133.264 103.745 118.796 103.319C104.328 102.894 105.321 94.6312 107.626 90.5532C105.498 90.5532 103.548 91.2624 102.838 91.6171C98.1576 93.3192 87.0583 112.539 82.0938 121.936H86.3491H97.3841Z"
      stroke="#011533"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M141.138 119.277C146.989 119.277 152.84 120.34 162.946 116.617C166.315 124.064 170.5 142.255 168.798 144.809C166.67 148 158.692 148 156.564 147.468C152.84 146.404 124.649 141.085 117.734 140.021C110.819 138.958 109.755 129.915 108.692 128.851C107.628 127.787 104.968 127.255 103.904 127.255C102.84 127.255 101.777 124.596 103.904 124.064C104.555 123.925 105.171 123.849 105.754 123.829C104.956 123.526 104.436 123.263 104.436 123C104.436 121.082 106.209 120.643 107.096 120.262C106.604 119.996 106.526 119.599 107.096 118.745C108.798 116.192 112.77 118.036 114.543 119.277C114.011 116.617 109.223 111.83 111.351 110.766C116.375 108.255 119.33 126.724 123.586 129.915C126.99 132.468 148.408 132.752 158.692 132.575H149.649L141.138 119.277Z"
      fill="white"
    />
    <path
      d="M114.543 119.277C114.011 116.617 109.223 111.83 111.351 110.766C116.375 108.255 119.33 126.724 123.586 129.915C126.99 132.468 148.408 132.752 158.692 132.575H149.649L141.138 119.277C146.989 119.277 152.84 120.34 162.946 116.617C166.315 124.064 170.5 142.255 168.798 144.809C166.67 148 158.692 148 156.564 147.468C152.84 146.404 124.649 141.085 117.734 140.021C110.819 138.958 109.755 129.915 108.692 128.851C107.628 127.787 104.968 127.255 103.904 127.255C102.84 127.255 101.777 124.596 103.904 124.064C109.862 122.787 112.947 126.901 114.011 128.851C112.947 125.128 104.436 124.064 104.436 123C104.436 121.082 106.209 120.643 107.096 120.262M114.543 119.277L117.202 125.128M114.543 119.277C112.77 118.036 108.798 116.192 107.096 118.745C106.526 119.599 106.604 119.996 107.096 120.262M107.096 120.262C108.44 120.99 112.879 120.737 115.606 126.192C115.251 124.898 113.052 121.901 107.096 120.262Z"
      stroke="#011533"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      d="M108.661 136.016H93.265C93.1087 137.599 92.4202 139.062 91.3321 140.125C90.2439 141.187 88.8331 141.774 87.3714 141.772H35.625C35.6279 143.295 36.1851 144.756 37.1747 145.833C38.1644 146.91 39.5058 147.517 40.9053 147.52H108.661C110.062 147.52 111.407 146.914 112.4 145.837C113.393 144.76 113.953 143.298 113.958 141.772V137.908C113.958 137.404 113.774 136.92 113.447 136.564C113.119 136.207 112.675 136.007 112.212 136.007L108.661 136.016Z"
      fill="white"
      stroke="#1D2943"
      strokeWidth="1.4"
      strokeMiterlimit="10"
    />
    <path
      d="M84.5653 102.436C85.0199 103.06 85.3469 103.766 85.5279 104.514L92.8366 134.74C92.9981 135.396 93.0403 136.075 92.9613 136.746C92.8047 138.191 92.1147 139.526 91.0242 140.496C89.9337 141.466 88.5198 142.002 87.0548 142H34.2331C32.899 142 31.6039 141.554 30.5565 140.735C29.5092 139.915 28.7706 138.77 28.46 137.484L21.1643 107.26C20.9546 106.395 20.9455 105.494 21.1378 104.624C21.3301 103.755 21.7187 102.94 22.2744 102.241C22.8302 101.542 23.5385 100.978 24.3462 100.589C25.1539 100.201 26.0398 99.9996 26.9374 100H79.7548C80.6225 99.9983 81.4799 100.187 82.2657 100.551C83.0515 100.916 83.7463 101.449 84.3006 102.111L84.5653 102.436Z"
      fill="white"
      stroke="#1D2943"
      strokeWidth="1.4"
      strokeMiterlimit="10"
    />
    <path
      d="M57.1881 126.95C60.6533 125.815 62.5862 122.008 61.5055 118.447C60.4247 114.886 56.7395 112.92 53.2743 114.055C49.8091 115.19 47.8761 118.996 48.9569 122.557C50.0377 126.118 53.7229 128.085 57.1881 126.95Z"
      fill="#E2E2FC"
    />
    <rect y="15" width="44" height="63" rx="12" fill="#E2E2FC" />
    <ellipse
      cx="135.319"
      cy="71.792"
      rx="6.38298"
      ry="7.97872"
      transform="rotate(44.1748 135.319 71.792)"
      fill="#1D2943"
    />
    <path
      d="M133.517 77.7875C132.318 80.4838 127.889 85.9737 119.769 86.3633"
      stroke="#1D2943"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M122 47.3438H123.052C123.052 47.3438 130.394 46.0528 134.094 48.4744C136.834 50.2677 138.155 52.0593 139.352 55.2585C140.809 59.1499 139.352 66 139.352 66H135.146C135.146 66 134.934 63.2249 134.62 61.4773C134.004 58.0499 133.938 55.7907 131.991 52.9972C129.347 49.2037 122 47.3438 122 47.3438Z"
      fill="#1D2943"
    />
    <ellipse
      cx="117.066"
      cy="85.9785"
      rx="2.86695"
      ry="3.58369"
      transform="rotate(90.0828 117.066 85.9785)"
      fill="#1D2943"
    />
    <path
      d="M4 148L177 148"
      stroke="#1D2943"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <mask
      id="mask0_12732_96992"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="12"
      width="47"
      height="68"
    >
      <rect y="12" width="47" height="68" rx="12" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_12732_96992)">
      <path
        d="M39.9697 64.0303C36.8791 63.5152 31.2681 62.0028 30.0595 60.7942C28.5575 59.2922 26.5578 55.3015 27.5242 51.7911C29.4451 52.0444 31.653 51.6468 33.5846 49.7151C38.117 45.1828 39.0224 36.5189 37.8667 28.4293C37.3933 25.1156 31.1503 21.3286 27.9258 21.3286C24.7408 21.3286 19.484 23.5283 16.4625 27.5571C15.7046 28.5675 15.517 30.3067 15.6692 32.4011C13.9692 31.3074 12.3993 31.5529 11.3576 33.6364C9.93742 36.4767 14.1974 37.8968 16.5641 37.8968C17.7632 43.2036 17.8175 48.2628 17.8175 50.2187C17.8175 53.7273 17.7597 58.9135 15.2417 60.4243C12.7237 61.9351 7.47976 61.4777 5.96898 62.4849C8.82268 66.01 13.3464 72.7879 25.0298 72.7879C39.634 72.7879 43.4953 70.5771 39.9697 64.0303Z"
        fill="white"
      />
      <path
        d="M18.9804 36.0033C17.8927 34.3433 16.7545 33.0992 15.6692 32.4011M15.6692 32.4011C13.9692 31.3074 12.3993 31.5529 11.3576 33.6364C9.93742 36.4767 14.1974 37.8968 16.5642 37.8968C17.7632 43.2036 17.8175 48.2628 17.8175 50.2187C17.8175 53.7273 17.7597 58.9135 15.2417 60.4243C12.7237 61.9351 7.47976 61.4777 5.96898 62.4849C8.82268 66.01 13.3464 72.7879 25.0298 72.7879C39.634 72.7879 43.4953 70.5771 39.9697 64.0303C36.8791 63.5152 31.2681 62.0028 30.0595 60.7942C28.5487 59.2834 26.5343 55.2547 27.5415 51.7295C26.7022 51.5617 24.7214 51.0245 23.5128 50.2187C25.3593 51.5617 29.9588 53.341 33.5846 49.7151C38.117 45.1828 39.0224 36.5189 37.8667 28.4293C37.3933 25.1156 31.1503 21.3286 27.9258 21.3286C24.7408 21.3286 19.484 23.5283 16.4625 27.5571C15.7046 28.5675 15.517 30.3067 15.6692 32.4011Z"
        stroke="#011533"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.707 33.6369C33.6064 29.8498 30.2708 34.2713 29.8679 36.6886C29.4651 39.1058 31.7144 41.0531 32.8895 41.7245"
        stroke="#011533"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7252 44.9698C29.8665 45.2719 27.6035 43.4241 26.8069 43.9539C26.4947 44.926 27.3328 46.7962 29.666 47.5455"
        stroke="#011533"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="1.00719"
        cy="1.51078"
        rx="1.00719"
        ry="1.51078"
        transform="matrix(-0.898794 -0.438371 -0.438371 0.898794 35.793 35.9395)"
        fill="#011533"
      />
      <ellipse
        cx="1.00719"
        cy="1.51078"
        rx="1.00719"
        ry="1.51078"
        transform="matrix(-0.898794 -0.438371 -0.438371 0.898794 27.2734 34.9927)"
        fill="#011533"
      />
      <path
        d="M23.1934 32.2654C24.6135 30.7959 26.507 30.3225 28.8739 31.792"
        stroke="#1D2943"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M13.4609 31.8503C17.5155 31.8503 19.2049 34.9904 19.5428 36.5605C19.3741 36.8745 19.9343 36.6685 20.0505 36.5605C21.0641 35.6184 21.0641 26.1981 22.5846 25.256C24.1051 24.314 27.6528 28.0822 32.2142 28.0822C35.8634 28.0822 39.4787 24.314 40.8302 22.4299H37.2825L39.8166 19.1327C38.634 19.4467 35.8634 19.9805 34.2415 19.6037C32.2142 19.1327 26.9315 11.9705 17.3019 17.1518C9.5982 21.2968 11.0957 29.0242 13.4609 31.8503Z"
        fill="#004360"
        stroke="#011533"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M16.5082 59C15.9913 60.0385 9.81455 60.5577 5.1621 62.1154C1.56971 63.3182 0.898859 65.5851 1.01144 66.6752L1.54319 86H46V65.2308C43.9322 62.7385 34.455 60.7308 29.9749 60.0385C29.6302 61.4231 27.9071 64.1923 23.7716 64.1923C19.6361 64.1923 16.8528 60.7308 16.5082 59Z"
        fill="#1D2943"
      />
      <path
        d="M1.02658 66.7885C1.02058 66.7523 1.0155 66.7145 1.01144 66.6752M1.01144 66.6752C0.898859 65.5851 1.56971 63.3182 5.1621 62.1154C9.81455 60.5577 15.9913 60.0385 16.5082 59C16.8528 60.7308 19.6361 64.1923 23.7716 64.1923C27.9071 64.1923 29.6302 61.4231 29.9749 60.0385C34.455 60.7308 43.9322 62.7385 46 65.2308V86H1.54319L1.01144 66.6752Z"
        stroke="#011533"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <line
        x1="13.6065"
        y1="34.3579"
        x2="15.6726"
        y2="35.4017"
        stroke="#1D2943"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </g>
    <rect
      x="0.7"
      y="12.7"
      width="45.6"
      height="66.6"
      rx="11.3"
      stroke="#011533"
      strokeWidth="1.4"
    />
    <path
      d="M71.5 31.3H71.2881L71.1117 31.4176L61.0983 38.0932L63.6413 32.2806L64.0703 31.3H63H61C56.9683 31.3 53.7 28.0317 53.7 24V12C53.7 7.96832 56.9683 4.7 61 4.7H130C134.032 4.7 137.3 7.96832 137.3 12V24C137.3 28.0317 134.032 31.3 130 31.3H71.5Z"
      fill="white"
      stroke="#1D2943"
      strokeWidth="1.4"
    />
    <path
      d="M97 39.6735C98.8367 37.0715 103.888 33.4286 109.398 39.6735C111.694 36.9183 117.755 33.061 123.633 39.6735C123.173 39.6735 130.52 31.4082 136.031 39.6735C135.571 39.6735 142.918 31.4081 148.888 39.6735C148.429 39.6735 155.316 31.4081 161.745 39.6735"
      stroke="#E2E2FC"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62 18.6735C63.8367 16.0715 68.8878 12.4286 74.398 18.6735C76.6939 15.9183 82.7551 12.061 88.6327 18.6735C88.1735 18.6735 95.5204 10.4082 101.031 18.6735C100.571 18.6735 107.918 10.4081 113.888 18.6735C113.429 18.6735 120.316 10.4081 126.745 18.6735"
      stroke="#E2E2FC"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="53"
      y1="84.0101"
      x2="56.0101"
      y2="81"
      stroke="#F9F9FF"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <line
      x1="52.9899"
      y1="81"
      x2="56"
      y2="84.01"
      stroke="#F9F9FF"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <line
      x1="8"
      y1="122.01"
      x2="11.0101"
      y2="119"
      stroke="#F9F9FF"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <line
      x1="7.98995"
      y1="119"
      x2="11"
      y2="122.01"
      stroke="#F9F9FF"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
)

export default BookCallIcon
